import { render, staticRenderFns } from "./purchase-method.vue?vue&type=template&id=9378fd1e&"
import script from "./purchase-method.vue?vue&type=script&lang=js&"
export * from "./purchase-method.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports